import React from "react";
import { motion } from "framer-motion";
import { Plus, Flame, Leaf, Star } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "../context/CartContext";
import { rupee, px } from "../lib/api";

export default function ProductCard({ item }) {
  const { addItem } = useCart();

  const add = () => {
    addItem(item, "menu");
    toast.success(`${item.name} added to cart`);
  };

  return (
    <motion.div
      data-testid={`product-card-${item.id}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="group bg-card border border-border rounded-lg overflow-hidden flex flex-col transition-all duration-300 hover:border-orange hover:-translate-y-1"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-brown-deep">
        <img
          src={px(item.image, 700)}
          alt={item.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brown-deep/80 to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          {item.bestseller && (
            <span className="flex items-center gap-1 bg-chick text-brown text-[11px] font-bold uppercase px-2 py-1 rounded">
              <Star className="w-3 h-3 fill-brown" /> Bestseller
            </span>
          )}
        </div>
        <div className="absolute top-3 right-3 flex gap-1.5">
          {item.veg ? (
            <span className="w-6 h-6 bg-green-600 rounded flex items-center justify-center" title="Veg">
              <Leaf className="w-3.5 h-3.5 text-white" />
            </span>
          ) : (
            <span className="w-6 h-6 bg-destructive rounded flex items-center justify-center" title="Non-veg">
              <span className="w-2.5 h-2.5 rounded-full bg-white" />
            </span>
          )}
        </div>
      </div>

      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-heading uppercase text-lg leading-tight tracking-tight">{item.name}</h3>
          <div className="flex gap-0.5 shrink-0 mt-1">
            {Array.from({ length: item.spicy }).map((_, i) => (
              <Flame key={i} className="w-3.5 h-3.5 text-orange fill-orange" />
            ))}
          </div>
        </div>
        <p className="text-cream/60 text-sm mt-1.5 flex-1">{item.desc}</p>
        <div className="flex items-center justify-between mt-4">
          <span className="font-heading text-2xl text-orange">{rupee(item.price)}</span>
          <button
            data-testid={`add-to-cart-${item.id}`}
            onClick={add}
            className="flex items-center gap-1.5 bg-orange text-primary-foreground font-bold uppercase text-sm px-4 py-2.5 rounded-md hover:scale-105 active:scale-95 transition-transform"
          >
            <Plus className="w-4 h-4" /> Add
          </button>
        </div>
      </div>
    </motion.div>
  );
}
